import { VehicleVisualsActionsComponent } from './templates/vehicle-visuals.actions.component';

export function VehicleVisualsCatalogCtrl (
  $state,
  $scope,
  $translate,
  blockUI,
  messages,
  VehicleVisuals
) {

  $scope.catalogBlock = blockUI.instances.get('catalogBlock');
  $scope.searched     = false;

  $scope.VehicleVisuals = new VehicleVisuals();

  $scope.attachTo = {
    inspection (visual) {
      $scope.attachToInspection(visual);
    },
    invoice (visual) {
      $scope.attachToInvoice(visual);
    }
  };

  $scope.tableSettings = {
    columns: [
      {
        classes: 'text-left',
        field  : 'title',
        header : {
          text: $translate.instant('VEHICLE_VISUALS_SPACE.PART')
        },
      },
      {
        classes: 'text-left',
        field  : 'description',
        header : {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        },
      },
      {
        component: {
          bindings: {
            outputs: {
              onAttachClick: event => $scope.attachToDocument(event),
              onEmailClick : event => $scope.emailVisual(event),
              onLaunchClick: event => $scope.launchVisual(event)
            }
          },
          enabled: true,
          factory: VehicleVisualsActionsComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('GENERAL_SPACE.STATUS.NO_RESULTS')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  $scope.attachToDocument = function (visual){
    if($scope.documentType == "invoice"){
      $scope.attachToInvoice(visual);
    } else {
      $scope.attachToInspection(visual)
    }
  }

  $scope.attachToInspection = function (visual) {
    $scope.VehicleVisuals.attachToInspection($scope.inspection, visual)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.ATTACHED_TO_INSPECTION'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.attachToInvoice = function (visual) {
    $scope.VehicleVisuals.attachToInvoice($scope.invoice, visual)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.ATTACHED_TO_INVOICE'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.emailVisual = function (visual) {
    $scope.VehicleVisuals.email($scope.customer.email, visual)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.EMAIL_SENT'), 'success');

    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.launchVisual = function (visual) {
    $scope.VehicleVisuals.play(visual)
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.refreshCatalog = function () {
    $scope.catalogBlock.start();

    $scope.VehicleVisuals.getCatalog()
    .finally(() => {
      $scope.catalogBlock.stop();
    });
  };

  $scope.search = function () {
    $scope.VehicleVisuals.search()
    .then(() => {
      $scope.searched = true;
    })
    .catch(err => {
      messages.error(err);
    });
  };
}